// extracted by mini-css-extract-plugin
export default {"workBox":"Work_workBox__E0bOl","workModule":"Work_workModule__DYLbi","githubLink":"Work_githubLink__Bdx3-"};